import { useAppContext } from "@context/app";
import { DialCodeItem } from "@types";
import { useIsMount } from "@utils/helpers";
import { useEffect, useState } from "react";

function usePhoneInput(onChange?: (v: any) => void, default_value?: string) {
  const [value, setValue] = useState<string>(default_value || "");
  const { country, syncData } = useAppContext();
  const [selectedDialCode, setSelectedDialCode] = useState<DialCodeItem | undefined>();
  const [openCountries, setOpenCountries] = useState(false);

  const isMount = useIsMount();

  // Find default dial code based on country
  useEffect(() => {
    if (syncData?.dialcodes && country) {
      const defaultDialCode = syncData.dialcodes.find((dc) =>
        dc.code2.toLowerCase() === country.code2.toLowerCase()
      );
      setSelectedDialCode((prev) => prev ? prev : defaultDialCode || syncData.dialcodes[0]);
    }
  }, [syncData, country]);

  useEffect(() => {
    if (!isMount) {
      handelChangeValue(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDialCode]);

  useEffect(() => {
    if (default_value && syncData?.dialcodes) {
      const setDefaultValue = async () => {
        const parsePhoneNumber = (await import("libphonenumber-js")).default;
        const phoneNumber = parsePhoneNumber(default_value);
        if (phoneNumber) {
          setValue(phoneNumber.nationalNumber);
          setSelectedDialCode((prev) =>
            syncData.dialcodes.find((x) =>
              x.dialcode.includes(phoneNumber.countryCallingCode)
            ) || prev
          );
        }
      }
      setDefaultValue();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [default_value, syncData?.dialcodes]);

  const handelChangeValue = (text: string) => {
    setValue(text);
    onChange?.(text ? `${selectedDialCode?.dialcode}${text}` : `${text}`);
  };

  const handelSelectedDialCode = (dialCode: DialCodeItem) => {
    setSelectedDialCode(dialCode);
    setOpenCountries(false);
  };

  return {
    value,
    setValue,
    selectedDialCode,
    setSelectedDialCode,
    handelSelectedDialCode,
    handelChangeValue,
    openCountries,
    setOpenCountries,
    dialcodes: syncData?.dialcodes || [],
  };
}

export default usePhoneInput;
